/** `registrations.status` — Registrations list filter and Edit modal (keep in sync with backend ALLOWED_REGISTRATION_STATUSES). */

export const REGISTRATION_STATUS_FILTER_ALL = 'all';

export const REGISTRATION_STATUS_OPTIONS = [
  { value: 'pending', label: 'Pending' },
  { value: 'on_hold', label: 'On Hold' },
  { value: 'confirmed', label: 'Confirmed' },
  { value: 'cancelled', label: 'Cancelled' },
  { value: 'cancellation_request', label: 'Cancellation_Request' },
  { value: 'camp_leader', label: 'Camp_Leader' },
  { value: 'instructor', label: 'Instructor' },
  { value: 'volunteer', label: 'Volunteer' },
  { value: 'photographer', label: 'Photographer' },
  { value: 'blogger', label: 'Blogger' },
  { value: 'rusticated', label: 'Rusticated' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'advanced_paid', label: 'Advanced_Paid' }
];

export const REGISTRATION_STATUS_FILTER_OPTIONS = [
  { value: REGISTRATION_STATUS_FILTER_ALL, label: 'All' },
  ...REGISTRATION_STATUS_OPTIONS
];

export function registrationStatusLabel(value) {
  if (value == null || String(value).trim() === '') return '—';
  const v = String(value).trim().toLowerCase();
  const hit = REGISTRATION_STATUS_OPTIONS.find((o) => o.value === v);
  if (hit) return hit.label;
  return String(value).replace(/_/g, ' ');
}
